import * as React from 'react';
import { useParams } from 'react-router';

import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useSettingsQuery } from '@admin/schema';

import { Breadcrumbs } from './breadcrumbs';
import { AccountSettingsForm } from './settings/form';

export const Settings: React.FC = () => {
  useTitle('Preferences');
  const { accountID } = useParams<{ accountID: string }>();
  const navigate = useNavigate();
  const { data } = useSettingsQuery({
    client,
    fetchPolicy: 'network-only',
    variables: { accountID: String(accountID) },
  });

  const onSave = () => {
    navigate(`/accounts/${accountID}`);
  };

  if (!data?.account) {
    return null;
  }

  return (
    <>
      <div className="page-header text-overflow">
        <Breadcrumbs account={data.account} active="Preferences" />
      </div>
      <AccountSettingsForm accountID={data.account.id} savedSettings={data.account.settings} onSave={onSave} />
    </>
  );
};
